export default __webpack_public_path__ + "static/media/menu.b5cbe023.svg";